<mat-chip-listbox
  [ngStyle]="{ 'max-height': maxHeight() }"
  style="overflow-y: auto"
  [ngClass]="{
    'mat-mdc-chip-set-stacked': isStacked(),
    'scroll-background': showScrollBackground(),
  }"
>
  @for (
    item of data();
    track item?.id ?? (titleKey() ? item[titleKey()] : item);
    let i = $index
  ) {
    <mat-chip
      class="wh-chip-{{ i }}"
      [@dynamicAnimation]="{
        value: 'center',
        params: { blurAmount: '2px' },
      }"
      [ngClass]="{ 'gradient-chip': item.gradient }"
      [matMenuTriggerFor]="menuItems().length > 0 ? menu : null"
      (click)="handleNavigate(item)"
      [disabled]="isDisabled() || isLoading()"
      [matTooltip]="getTooltip(item)"
    >
      <img
        *ngIf="
          imageKey() &&
            item[imageKey()] &&
            (item[imageKey()]
              | WHImgAuthHeader: placeholderImg()
              | async) as image;
          else placeholderimg
        "
        alt=""
        [src]="image"
        matChipAvatar
      />
      <ng-template #placeholderimg>
        <i
          *ngIf="item.gradient"
          matChipAvatar
          class="b-fa b-fa-people-roof wh-icon-scale"
        ></i>
        <mat-icon
          matChipAvatar
          *ngIf="!item.gradient && matIcon()"
          style="overflow: visible"
          >{{ matIcon() }}</mat-icon
        >
        <i
          *ngIf="!item.gradient && icon()"
          matChipAvatar
          class="workheld-icons wh-icon-scale"
          [innerHTML]="item['icon'] ? item['icon'] : icon()"
        ></i>
        <img
          *ngIf="!item.gradient && placeholderImg()"
          [src]="placeholderImg()"
          alt=""
          matChipAvatar
        />
      </ng-template>

      <ng-container *ngIf="titleKey()">
        {{ item[titleKey()] }}
      </ng-container>
      <div
        matChipRemove
        class="chip-remove-container"
        [style.width.px]="
          isRemoveButtonVisible() || item.isRemovable
            ? getBadge(item)
              ? 44
              : 20
            : getBadge(item)
              ? 20
              : 0
        "
      >
        <span class="skill-count" *ngIf="getBadge(item)">
          {{ getBadge(item) }}
        </span>

        <mat-icon
          style="z-index: 999"
          class="remove-icon-style remove-chip-button"
          *ngIf="(isRemoveButtonVisible() || item.isRemovable) && !isLoading()"
          [hidden]="!isRemoveButtonVisible() || !item.isRemovable"
          (click)="onRemoveChip($event, item)"
        >
          cancel
        </mat-icon>

        <mat-spinner
          [diameter]="15"
          class="remove-icon-style remove-chip-button"
          *ngIf="
            (isRemoveButtonVisible() || item.isRemovable) &&
            isLoading() &&
            removingChip() === item
          "
          [hidden]="!isRemoveButtonVisible() || !item.isRemovable"
        >
        </mat-spinner>
      </div>

      <!-- Kept outside matChipRemove, which stops click propagation -->
      <mat-icon
        *ngIf="suffixIcon()"
        matChipTrailingIcon
        class="remove-icon-style"
      >
        {{ suffixIcon() }}
      </mat-icon>

      <mat-menu #menu="matMenu">
        @for (menuItem of menuItems(); track menuItem) {
          <button
            *ngIf="
              (item.gradient && menuItem.actionKey === 'unassign') ||
              (!item.gradient && menuItem.actionKey === 'assign') ||
              (menuItem.actionKey !== 'unassign' &&
                menuItem.actionKey !== 'assign')
            "
            mat-menu-item
            (click)="onMenuItemClick(item, menuItem.actionKey)"
            [disabled]="
              (menuItem?.disableById
                ? item?.id === menuItem?.disableById
                : false && menuItem?.disableByObjectKey
                  ? !item[menuItem.disableByObjectKey]
                  : false) ||
              (menuItem?.disableByObjectKey
                ? !item[menuItem.disableByObjectKey]
                : false)
            "
          >
            {{ menuItem.translateKey | translate }}
          </button>
        }
      </mat-menu>
    </mat-chip>
  }
</mat-chip-listbox>
